import { Injectable } from '@angular/core';
import { Api, User } from '@providers/index'

@Injectable()
export class Project {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/project/project', params);
  }
  

  post(params?: any) {
    if(params.id=='' || params.id==undefined){
      params.created_by = this.user.data.employee_id;
    }else{
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/project/project', params);
  }


  getProjectStat(params?: any) {
    return this.api.get('index.php/project/dashboard/project_stat', params);
  }

  stat_per_dept(params?: any) {
    return this.api.get('index.php/project/dashboard/per_department', params);
  }

  getDetailUsage(params?: any){
    return this.api.get('index.php/project/project/usageDetail', params);
  }

  getListAR(params?: any) {
    return this.api.get('index.php/project/project/getListAR', params);
  }

  getListAdvance(params?: any){
    return this.api.post('index.php/project/project/listAdvance', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/project_providers/project/project.ts